// tracking-utils.js
window.TrackingParams = (function () {
  console.log('[TrackingParams] Initializing...');
  const urlParams = new URLSearchParams(window.location.search);

  const gclid = urlParams.get('gclid') || null;
  const fbclid = urlParams.get('fbclid') || null;

  // Store in sessionStorage to isolate per tab
  if (gclid) sessionStorage.setItem('tracking_gclid', gclid);
  if (fbclid) sessionStorage.setItem('tracking_fbclid', fbclid);

  // Decide what to send, prioritizing URL params over stored values
  let sendGclid = gclid || sessionStorage.getItem('tracking_gclid') || 'false';
  let sendFbclid = fbclid || sessionStorage.getItem('tracking_fbclid') || 'false';

  console.log('[TrackingParams] URL:', window.location.href);
  console.log('[TrackingParams] gclid:', sendGclid, 'fbclid:', sendFbclid);

  return {
    getGclid: () => sendGclid,
    getFbclid: () => sendFbclid,
    setHiddenInputs: (formId) => {
      const form = document.getElementById(formId);
      if (!form) {
        console.error('[TrackingParams] Form not found:', formId);
        return;
      }

      let gInput = form.querySelector('#gclid_status');
      let fInput = form.querySelector('#fbclid_status');

      if (!gInput) {
        gInput = document.createElement('input');
        gInput.type = 'hidden';
        gInput.id = 'gclid_status';
        gInput.name = 'contact[gclid]';
        form.appendChild(gInput);
      }
      if (!fInput) {
        fInput = document.createElement('input');
        fInput.type = 'hidden';
        fInput.id = 'fbclid_status';
        fInput.name = 'contact[fbclid]';
        form.appendChild(fInput);
      }

      gInput.value = sendGclid;
      fInput.value = sendFbclid;

      console.log('[TrackingParams] Set form inputs:', {
        formId,
        gclid: gInput.value,
        fbclid: fInput.value
      });
    },
    clearTracking: () => {
      sessionStorage.removeItem('tracking_gclid');
      sessionStorage.removeItem('tracking_fbclid');
      console.log('[TrackingParams] Cleared sessionStorage tracking data');
    }
  };
})();